"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
/** Generic tooltip component. Defaults to a small ? icon. If children are passed, those will render instead of the icon.
 * Extends [MUI's tooltip](https://mui.com/api/tooltip/#props).
 */
const Tooltip = ({ Icon = common_buoy_icons_1.HelpIcon, 
// eslint-disable-next-line @typescript-eslint/no-shadow
IconProps, children, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { arrow: true, placement: "top", slotProps: {
            tooltip: {
                sx: {
                    fontSize: "12px",
                    textAlign: "center",
                    lineHeight: "18px",
                },
            },
        }, ...rest, children: children || ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Icon, { size: 14, ...IconProps }) })) }));
};
exports.default = (0, common_buoy_theme_1.withTheme)(Tooltip);
//# sourceMappingURL=index.js.map